/**
 * 主题管理（浅色 / 深色）
 *
 * 切换时给 <html> 设置 data-theme + dark 类（Element Plus 深色依赖 html.dark），
 * CSS 变量自动切换；选择结果存 localStorage。
 */
import { ref, watch } from 'vue'
import { applyThemeToDocument, readStoredTheme, type ThemeName } from '@/utils/theme-dom'

const theme = ref<ThemeName>(readStoredTheme())

function apply(t: ThemeName) {
  theme.value = t
  applyThemeToDocument(t)
}

apply(theme.value)

export function useTheme() {
  const isDark = () => theme.value === 'dark'

  const toggle = () => apply(theme.value === 'light' ? 'dark' : 'light')

  const setTheme = (t: ThemeName) => apply(t)

  /** 跟随系统（仅在用户没手动切换过时调用） */
  const followSystem = () => {
    if (localStorage.getItem('niuren-theme')) return
    const dark = window.matchMedia?.('(prefers-color-scheme: dark)').matches
    apply(dark ? 'dark' : 'light')
  }

  watch(theme, (v) => applyThemeToDocument(v))

  return { theme, isDark, toggle, setTheme, followSystem }
}
